<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <ChartNav @multiDrill="multiDrill" :currentDrillRouteIndex="currentDrillRouteIndex" @multiJump="multiJump"
              :multiActionsParam="multiActionsParam" v-model="drillIndex" :prop='prop'
              :option="option"
              :drillClickList="drillClickList"
              :drillDimList="drillDimList"></ChartNav>
    <IndexCard
        :dataOption="prop"
        ref="indexCard"
        :dataChart="dataChart"
        :schema="schema"
        @handleIndexCardClick="handleInnerClick"
        :layoutType="option.layoutType"
    ></IndexCard>
  </div>
</template>

<script setup>
import IndexCard from "./IndexCard.vue";
</script>
<script>
import circleImg from "@/assets/img/circle.png";

export default {
  name: "indexCard",
  computed: {
    schema() {
      return {prop: this.option, themeCfg: this.themeCfg};
    },
  },
  mounted() {
  },
  methods: {
    handlerDimParam(param) {
      param.componentType = 'indexCard';
      return param
    },
    updateChart() {
      this.$refs["indexCard"]?.handlerRes();
    },
    handleInnerClick(e) {
      // 根据外框在屏幕x,y的位置和事件在屏幕x,y的位置，计算出实际事件在组件内的偏移位置
      const {
        x,
        y,
      } = this.$refs.indexCard.$el?.getBoundingClientRect()
      const event = {
        ...e.event,
        offsetX: e.event?.x - x,
        offsetY: e.event?.y - y,
      }
      this.handleClick({
        ...e,
        event,
      })
    }
  },
};
</script>



